import { axiosInstance } from '@/services/api/axios';
import type {
  CandidateApplicationItem,
  PaginatedData,
  SavedJobItem,
  SaveJobResult,
} from '@/services/api/types';

/**
 * Candidate-scoped endpoints (GET/POST/DELETE under /candidates/me/*).
 *
 * All calls go through `axiosInstance`, which attaches the candidate bearer
 * token + X-Device-Signature and handles 401 → refresh/retry. These routes are
 * scoped to the logged-in candidate, so never pass an organizationId.
 */
export const candidateApi = {
  getApplications: async (
    page = 1,
    limit = 20,
  ): Promise<PaginatedData<CandidateApplicationItem>> => {
    const res = await axiosInstance.get('candidates/me/applications', {
      params: { page, limit },
    });
    return res.data.data;
  },

  getSavedJobs: async (
    page = 1,
    limit = 50,
  ): Promise<PaginatedData<SavedJobItem>> => {
    const res = await axiosInstance.get('candidates/me/saved-jobs', {
      params: { page, limit },
    });
    return res.data.data;
  },

  saveJob: async (jobPostingId: string): Promise<SaveJobResult> => {
    const res = await axiosInstance.post('candidates/me/saved-jobs', { jobPostingId });
    return res.data.data;
  },

  removeSavedJob: async (jobPostingId: string): Promise<{ removed: boolean }> => {
    const res = await axiosInstance.delete(
      `candidates/me/saved-jobs/${encodeURIComponent(jobPostingId)}`,
    );
    return res.data.data;
  },
};
